// extracted by mini-css-extract-plugin
export default {"icon":"CPqZXS6o5xgbh9nnb18v","iconButton":"WDF91z3JWdwVeDWFOpa5"};